import { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { CalendarClock } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const todayISO = () => new Date().toISOString().slice(0, 10);

// Botón admin para corregir el vencimiento de un lote (cualquier depósito o subdepósito).
export function EditLotExpiration({ lot, onSaved }) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState((lot?.expiration_date || '').slice(0, 10));
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (value && value < todayISO()) {
      toast.error('El vencimiento no puede ser anterior a hoy'); return;
    }
    setSaving(true);
    try {
      await axios.patch(`${BACKEND_URL}/api/stock-lots/${lot.lot_id}/expiration`,
        { expiration_date: value || null }, { withCredentials: true });
      toast.success('Vencimiento corregido');
      setOpen(false);
      onSaved?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error al corregir el vencimiento');
    } finally { setSaving(false); }
  };

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-6 w-6 text-amber-600 hover:text-amber-700"
        title="Corregir vencimiento (admin)"
        onClick={(e) => { e.stopPropagation(); setValue((lot?.expiration_date || '').slice(0, 10)); setOpen(true); }}
        data-testid={`edit-exp-btn-${lot.lot_id}`}
      >
        <CalendarClock className="w-3.5 h-3.5" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="edit-exp-dialog">
          <DialogHeader>
            <DialogTitle>Corregir vencimiento</DialogTitle>
            <DialogDescription>
              Lote <b>{lot?.lot_number || '—'}</b>. Solo administradores. No se admiten fechas anteriores a hoy.
            </DialogDescription>
          </DialogHeader>
          <div>
            <Label className="text-xs">Nuevo vencimiento</Label>
            <Input type="date" min={todayISO()} value={value} onChange={(e) => setValue(e.target.value)} data-testid="edit-exp-input" />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button>
            <Button onClick={save} disabled={saving} data-testid="edit-exp-save">{saving ? 'Guardando…' : 'Guardar'}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
